
var id = "emp_search";
var markup = "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 17 18\" id=\"emp_search\">\n<title>Group</title>\n<g id=\"emp_search_模版消息-模版消息\">\n\t<g id=\"emp_search_Group\" transform=\"translate(0.125000, 0.125000)\">\n\t\t<path id=\"emp_search_Shape\" class=\"st0\" d=\"M16.7,17l-1.4-1.5c0.5-0.6,0.8-1.5,0.8-2.3c0-2.1-1.7-3.9-3.9-3.9s-3.9,1.7-3.9,3.9\n\t\t\ts1.7,3.9,3.9,3.9c0.9,0,1.7-0.3,2.3-0.8l1.4,1.5c0.1,0.1,0.2,0.2,0.4,0.2s0.3-0.1,0.4-0.2c0.1-0.1,0.2-0.2,0.2-0.4\n\t\t\tC16.9,17.2,16.8,17.1,16.7,17L16.7,17z M12.2,16c-1.6,0-2.8-1.3-2.8-2.8c0-1.6,1.3-2.8,2.8-2.8c1.6,0,2.8,1.3,2.8,2.8\n\t\t\tC15,14.8,13.8,16,12.2,16z\" />\n\t\t<path id=\"emp_search_Fill-3\" class=\"st1\" d=\"M1.1,16.7v-1c0-3.4,2.6-6.3,5.8-6.6h0c0.2,0,0.4,0,0.6,0h0.1C8.3,9,9.4,8.8,9.9,8.3l0.3-0.2\n\t\t\tc1.1-0.9,1.7-2.2,1.7-3.6c0-2.5-2-4.6-4.5-4.6C5-0.1,3,1.9,3,4.5c0,1.4,0.6,2.7,1.7,3.6L5,8.3L4.7,8.5c-2.9,1.2-4.8,4-4.8,7.2v1.6\n\t\t\tc0,0.3,0.3,0.6,0.6,0.6h8.4c-0.3-0.4-0.5-0.8-0.7-1.2L1.1,16.7z M4.2,4.4c0-1.9,1.5-3.4,3.3-3.4s3.3,1.5,3.3,3.4S9.3,7.8,7.5,7.8\n\t\t\tC5.7,7.8,4.2,6.3,4.2,4.4z\" />\n\t</g>\n</g>\n</symbol>";
(function injectSprite() {
  if (typeof document === 'undefined') return;
  var SPRITE_ID = '__UMI_SVG_SPRITE__';
  function ensure() {
    var root = document.getElementById(SPRITE_ID);
    if (!root) {
      root = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      root.setAttribute('id', SPRITE_ID);
      root.setAttribute('aria-hidden', 'true');
      root.setAttribute('style', 'position:absolute;width:0;height:0;overflow:hidden');
      var parent = document.body || document.documentElement;
      parent.insertBefore(root, parent.firstChild);
    }
    if (document.getElementById(id)) return;
    try {
      root.insertAdjacentHTML('beforeend', markup);
      return;
    } catch (e) {}
    try {
      var doc = new DOMParser().parseFromString(
        '<svg xmlns="http://www.w3.org/2000/svg">' + markup + '</svg>',
        'image/svg+xml'
      );
      var node = doc.querySelector('symbol');
      if (node) root.appendChild(document.importNode(node, true));
    } catch (e2) {}
  }
  if (document.body || document.documentElement) ensure();
  else document.addEventListener('DOMContentLoaded', ensure);
})();
module.exports = id;
module.exports.default = id;
module.exports.id = id;
